// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u {
  text-align: left;
  margin-bottom: 32px;
  border: 1px solid #dddee0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___numbers--RwPfQ {
    padding: 0 16px;
    color: #6d717a;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___numbers--RwPfQ .components-BookingDetails-Hotel-styles___highlight--VtLBd {
      color: #1b2432;
      font-weight: 500;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___hotelDetailsTitle--Ch6GQ {
    font-size: 17px;
    color: #1b2432;
    letter-spacing: 0;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___row--C81Zz {
    padding: 20px 0;
    border-bottom: 1px solid #c6c8cc;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___row--C81Zz.components-BookingDetails-Hotel-styles___no-border--jbJzY {
      border: none;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___row--C81Zz .components-BookingDetails-Hotel-styles___baseFare--zz2Zg {
      text-align: right;
      line-height: 22px;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___row--C81Zz .components-BookingDetails-Hotel-styles___baseFare--zz2Zg .components-BookingDetails-Hotel-styles___baseprice--abWrz {
        font-size: 15px;
        color: #1b2432;
        letter-spacing: 0;
      }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___row--C81Zz .components-BookingDetails-Hotel-styles___baseFare--zz2Zg .components-BookingDetails-Hotel-styles___price--CQHU4 {
        font-size: 13px;
        color: #1b2432;
        letter-spacing: 0;
      }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___row--C81Zz .components-BookingDetails-Hotel-styles___baseFare--zz2Zg .components-BookingDetails-Hotel-styles___fees--CcTnn {
        font-size: 13px;
        color: #6d717a;
        letter-spacing: 0;
      }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___title--HL2s5 {
    font-size: 15px;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___fees--CcTnn {
    font-size: 13px;
    color: #6d717a;
    letter-spacing: 0;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___subtitle--QbI3p {
    font-size: 13px;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___cancelPolicyRow--E5s_c {
    display: flex;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___cancelPolicyRow--E5s_c .components-BookingDetails-Hotel-styles___cancelPolicy--qvO3D {
      flex: 1;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___cancelPolicyRow--E5s_c .components-BookingDetails-Hotel-styles___cancelPolicy--qvO3D .components-BookingDetails-Hotel-styles___highlight--VtLBd {
        margin-top: 2px;
      }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___cancelPolicyRow--E5s_c .components-BookingDetails-Hotel-styles___icon--vD0qF {
      color: #318afb;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___withPrice--M7MIJ {
    display: flex;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___withPrice--M7MIJ .components-BookingDetails-Hotel-styles___title--HL2s5,
    .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___withPrice--M7MIJ .components-BookingDetails-Hotel-styles___subtitle--QbI3p {
      flex: 1;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___withPrice--M7MIJ .components-BookingDetails-Hotel-styles___title--HL2s5 svg, .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___withPrice--M7MIJ .components-BookingDetails-Hotel-styles___subtitle--QbI3p svg {
        margin-left: 6px;
        transition: transform 150ms ease;
      }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___withPrice--M7MIJ .components-BookingDetails-Hotel-styles___fees--CcTnn {
      font-size: 13px;
      color: #6d717a;
      letter-spacing: 0;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___withPrice--M7MIJ .components-BookingDetails-Hotel-styles___subtitle--QbI3p {
      padding-left: 16px;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___withPrice--M7MIJ .components-BookingDetails-Hotel-styles___price--CQHU4 {
      color: #1b2432;
      font-weight: 500;
      font-size: 15px;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___withPrice--M7MIJ .components-BookingDetails-Hotel-styles___price--CQHU4.components-BookingDetails-Hotel-styles___total--ozZxo {
        font-size: 21px;
        font-weight: 600;
      }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___dropdown--ObArS {
    padding-left: 15px;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___rotate--WsTBU svg {
      transform: rotate(180deg);
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___buttonWrapper--gaZ1G {
    padding: 16px 0;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___button--EqoQ2 {
    text-transform: initial;
    padding: 16px;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___warning_container--KpBI6 {
    display: flex;
    margin-top: 5px;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___warning_container--KpBI6 .components-BookingDetails-Hotel-styles___warning--QSIT6 {
      flex: 1;
      color: #6d717a;
      font-size: 13px;
      line-height: 17px;
      text-align: left;
      padding-bottom: 16px;
      padding-right: 15px;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___warning_container--KpBI6 .components-BookingDetails-Hotel-styles___warning--QSIT6 span {
        color: #fc3b60 !important;
      }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___warning_container--KpBI6 .components-BookingDetails-Hotel-styles___icon--vD0qF {
      color: #318afb;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___warning_container--KpBI6 div svg {
        cursor: pointer;
      }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___warning_container--KpBI6 .components-BookingDetails-Hotel-styles___multiWarning--ldukT {
      flex: 1;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___terms--n_cdY {
    color: #6d717a;
    font-size: 13px;
    line-height: 17px;
    text-align: center;
    padding-bottom: 16px;
  }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___terms--n_cdY span {
      font-weight: 500;
    }

  .components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u .components-BookingDetails-Hotel-styles___terms--n_cdY a {
      color: #318afb;
    }

.components-BookingDetails-Hotel-styles___totalPrice--vuMIv {
  flex: 1;
  letter-spacing: 0;
  font-size: 15px;
  color: #1b2432;
  letter-spacing: 0;
  font-weight: bold;
}

.components-BookingDetails-Hotel-styles___segmentDetail--raleY {
  border: none !important;
  webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.components-BookingDetails-Hotel-styles___segmentDetail--raleY .components-BookingDetails-Hotel-styles___container--jiKBx {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 32px 32px 0 32px;
  }

.components-BookingDetails-Hotel-styles___segmentDetail--raleY .components-BookingDetails-Hotel-styles___container--jiKBx .components-BookingDetails-Hotel-styles___destinations--v2KAw {
      font-size: 30px;
      color: #1b2432;
      letter-spacing: 0;
      min-width: 180px;
      align-self: center;
    }

.components-BookingDetails-Hotel-styles___segmentDetail--raleY .components-BookingDetails-Hotel-styles___container--jiKBx .components-BookingDetails-Hotel-styles___destinations--v2KAw svg {
        margin: 0 20px;
      }

.components-BookingDetails-Hotel-styles___segmentDetail--raleY .components-BookingDetails-Hotel-styles___container--jiKBx .components-BookingDetails-Hotel-styles___details--VvEKt {
      font-size: 25px;
      color: #1b2432;
      letter-spacing: 0;
      margin: 0;
    }

.components-BookingDetails-Hotel-styles___segmentDetail--raleY .components-BookingDetails-Hotel-styles___container--jiKBx .components-BookingDetails-Hotel-styles___labels--BYeB7 {
      font-size: 11px;
      color: #6d717a;
      letter-spacing: 0;
      margin-bottom: 8px;
      margin-top: 0;
      font-weight: 400;
    }

.components-BookingDetails-Hotel-styles___segmentDetail--raleY .components-BookingDetails-Hotel-styles___container--jiKBx .components-BookingDetails-Hotel-styles___airline--is3Ln {
      margin-bottom: 0;
    }

.components-BookingDetails-Hotel-styles___segmentDetail--raleY .components-BookingDetails-Hotel-styles___buttons--Rofiq .components-BookingDetails-Hotel-styles___button--EqoQ2 {
      color: #318afb;
      min-width: 74px;
      height: 32px;
    }

.components-BookingDetails-Hotel-styles___segmentDetail--raleY .components-BookingDetails-Hotel-styles___withBorder--rPgWl {
    border-bottom: 1px solid #dddee0;
  }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 {
  padding: 32px;
  padding-bottom: 0;
  margin-bottom: 32px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___header--eI1uo {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #dddee0;
    padding-bottom: 12px;
    text-align: left;
    align-items: center;
  }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___header--eI1uo .components-BookingDetails-Hotel-styles___title--HL2s5 {
      font-size: 13px;
      color: #6d717a;
      letter-spacing: 0;
    }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___header--eI1uo .components-BookingDetails-Hotel-styles___description--JGVw0 {
      font-size: 15px;
      color: #1b2432;
      letter-spacing: 0;
      font-weight: 500;
    }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___header--eI1uo .components-BookingDetails-Hotel-styles___confNumb--wUY3s {
      font-size: 11px;
      color: #6d717a;
      letter-spacing: 0;
      margin-bottom: 4px;
    }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___header--eI1uo .components-BookingDetails-Hotel-styles___confNumb--wUY3s + p {
      margin-top: 8px;
    }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___header--eI1uo .components-BookingDetails-Hotel-styles___hotelName--yT6Ky {
      font-size: 21px;
      color: #1b2432;
      letter-spacing: 0;
      margin: 0;
    }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___header--eI1uo .components-BookingDetails-Hotel-styles___hotelName--yT6Ky .components-BookingDetails-Hotel-styles___title--HL2s5 {
        margin-top: 6px;
      }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___hotelInfo--Z3QPx {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #dddee0;
    padding: 12px 0;
    text-align: left;
  }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___hotelInfo--Z3QPx .components-BookingDetails-Hotel-styles___title--HL2s5 {
      font-size: 13px;
      color: #6d717a;
      letter-spacing: 0;
      margin-bottom: 4px;
    }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___hotelInfo--Z3QPx .components-BookingDetails-Hotel-styles___description--JGVw0 {
      font-size: 15px;
      color: #1b2432;
      letter-spacing: 0;
      font-weight: 500;
      margin-top: 2px;
      padding-right: 40px;
    }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___placeInfo--DRlKU {
    display: flex;
    flex-direction: row;
    padding: 12px 0;
    text-align: left;
    align-items: center;
    justify-content: space-between;
  }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___placeInfo--DRlKU .components-BookingDetails-Hotel-styles___star--U9Tkm {
      display: flex;
      align-items: center;
    }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___placeInfo--DRlKU .components-BookingDetails-Hotel-styles___star--U9Tkm .components-BookingDetails-Hotel-styles___description--JGVw0 {
        padding-right: 40px;
        font-size: 15px;
        color: #6d717a;
      }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___placeInfo--DRlKU .components-BookingDetails-Hotel-styles___rating--zrhnQ {
      text-align: right;
    }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___placeInfo--DRlKU .components-BookingDetails-Hotel-styles___rating--zrhnQ .components-BookingDetails-Hotel-styles___ratingText--jZXKG {
        font-family: 'Roboto';
        font-weight: 500;
        font-size: 15px;
        color: #008e64;
        letter-spacing: 0;
        text-align: right;
        margin-bottom: 6px;
      }

.components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0 .components-BookingDetails-Hotel-styles___placeInfo--DRlKU .components-BookingDetails-Hotel-styles___rating--zrhnQ .components-BookingDetails-Hotel-styles___ratingCount--RD6SX {
        margin-top: 6px;
        font-family: 'Roboto';
        font-weight: 400;
        font-size: 13px;
        color: #6d717a;
        letter-spacing: 0;
        text-align: right;
      }

.components-BookingDetails-Hotel-styles___cancelInfoIcon--MirQU {
  align-self: center;
  cursor: pointer;
}

.components-BookingDetails-Hotel-styles___confirmationBodyTextStyle--NhueW {
  width: 450px;
  padding-left: 32px !important;
  padding-right: 32px !important;
  padding-bottom: 10px !important;
}
`, "",{"version":3,"sources":["webpack://./components/BookingDetails/Hotel/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;AA6K7C;;EA3KE;IACE,eAAe;IACf,cAAc;EAMhB;;EAJE;MACE,cAAc;MACd,gBAAgB;IAClB;;EAGF;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gCAAgC;EA0BlC;;EAxBE;MACE,YAAY;IACd;;EAEA;MACE,iBAAiB;MACjB,iBAAiB;IAiBnB;;EAfE;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;MACnB;;EACA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;MACnB;;EACA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;MACnB;;EAIJ;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EAaf;;EAXE;MACE,OAAO;IAKT;;EAHE;QACE,eAAe;MACjB;;EAGF;MACE,cAAc;IAChB;;EAGF;IACE,aAAa;EA+Bf;;EA7BE;;MAEE,OAAO;IAKT;;EAJE;QACE,gBAAgB;QAChB,gCAAgC;MAClC;;EAGF;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;;EAEA;MACE,kBAAkB;IACpB;;EAEA;MACE,cAAc;MACd,gBAAgB;MAChB,eAAe;IAMjB;;EAJE;QACE,eAAe;QACf,gBAAgB;MAClB;;EAIJ;IACE,kBAAkB;EACpB;;EAGE;MACE,yBAAyB;IAC3B;;EAGF;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EAwBjB;;EAvBE;MACE,OAAO;MACP,cAAc;MACd,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;IAIrB;;EAHE;QACE,yBAAyB;MAC3B;;EAEF;MACE,cAAc;IAChB;;EAEE;QACE,eAAe;MACjB;;EAEF;MACE,OAAO;IACT;;EAEF;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;EAStB;;EAPE;MACE,gBAAgB;IAClB;;EAEA;MACE,cAAc;IAChB;;AAIJ;EACE,OAAO;EACP,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAElC,2BAA2B;AAkD7B;;AAhDE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wBAAwB;EAgC1B;;AA9BE;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,kBAAkB;IAKpB;;AAHE;QACE,cAAc;MAChB;;AAGF;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,SAAS;IACX;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,kBAAkB;MAClB,aAAa;MACb,gBAAgB;IAClB;;AACA;MACE,gBAAgB;IAClB;;AAIA;MACE,cAAc;MACd,eAAe;MACf,YAAY;IACd;;AAEF;IACE,gCAAgC;EAClC;;AAGF;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAkH7C;;AAhHE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gCAAgC;IAChC,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;EAoCrB;;AAlCE;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;IAClB;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,kBAAkB;IACpB;;AAEA;MACE,eAAe;IACjB;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,SAAS;IAKX;;AAHE;QACE,eAAe;MACjB;;AAIJ;IACE,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;EAiBlB;;AAfE;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,kBAAkB;IACpB;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;IACrB;;AAGF;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;EAoChC;;AAlCE;MACE,aAAa;MACb,mBAAmB;IAOrB;;AALE;QACE,mBAAmB;QACnB,eAAe;QACf,cAAc;MAChB;;AAGF;MACE,iBAAiB;IAqBnB;;AAnBE;QACE,qBAAqB;QACrB,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;MACpB;;AAEA;QACE,eAAe;QACf,qBAAqB;QACrB,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,iBAAiB;MACnB;;AAKN;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC","sourcesContent":[".hotelDetails {\n  text-align: left;\n  margin-bottom: 32px;\n  border: 1px solid #dddee0;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);\n\n  .numbers {\n    padding: 0 16px;\n    color: #6d717a;\n\n    .highlight {\n      color: #1b2432;\n      font-weight: 500;\n    }\n  }\n\n  .hotelDetailsTitle {\n    font-size: 17px;\n    color: #1b2432;\n    letter-spacing: 0;\n  }\n\n  .row {\n    padding: 20px 0;\n    border-bottom: 1px solid #c6c8cc;\n\n    &.no-border {\n      border: none;\n    }\n\n    .baseFare {\n      text-align: right;\n      line-height: 22px;\n\n      .baseprice {\n        font-size: 15px;\n        color: #1b2432;\n        letter-spacing: 0;\n      }\n      .price {\n        font-size: 13px;\n        color: #1b2432;\n        letter-spacing: 0;\n      }\n      .fees {\n        font-size: 13px;\n        color: #6d717a;\n        letter-spacing: 0;\n      }\n    }\n  }\n\n  .title {\n    font-size: 15px;\n  }\n\n  .fees {\n    font-size: 13px;\n    color: #6d717a;\n    letter-spacing: 0;\n  }\n\n  .subtitle {\n    font-size: 13px;\n  }\n\n  .cancelPolicyRow {\n    display: flex;\n\n    .cancelPolicy {\n      flex: 1;\n\n      .highlight {\n        margin-top: 2px;\n      }\n    }\n\n    .icon {\n      color: #318afb;\n    }\n  }\n\n  .withPrice {\n    display: flex;\n\n    .title,\n    .subtitle {\n      flex: 1;\n      svg {\n        margin-left: 6px;\n        transition: transform 150ms ease;\n      }\n    }\n\n    .fees {\n      font-size: 13px;\n      color: #6d717a;\n      letter-spacing: 0;\n    }\n\n    .subtitle {\n      padding-left: 16px;\n    }\n\n    .price {\n      color: #1b2432;\n      font-weight: 500;\n      font-size: 15px;\n\n      &.total {\n        font-size: 21px;\n        font-weight: 600;\n      }\n    }\n  }\n\n  .dropdown {\n    padding-left: 15px;\n  }\n\n  .rotate {\n    svg {\n      transform: rotate(180deg);\n    }\n  }\n\n  .buttonWrapper {\n    padding: 16px 0;\n  }\n\n  .button {\n    text-transform: initial;\n    padding: 16px;\n  }\n\n  .warning_container {\n    display: flex;\n    margin-top: 5px;\n    .warning {\n      flex: 1;\n      color: #6d717a;\n      font-size: 13px;\n      line-height: 17px;\n      text-align: left;\n      padding-bottom: 16px;\n      padding-right: 15px;\n      span {\n        color: #fc3b60 !important;\n      }\n    }\n    .icon {\n      color: #318afb;\n    }\n    div {\n      svg {\n        cursor: pointer;\n      }\n    }\n    .multiWarning {\n      flex: 1;\n    }\n  }\n  .terms {\n    color: #6d717a;\n    font-size: 13px;\n    line-height: 17px;\n    text-align: center;\n    padding-bottom: 16px;\n\n    span {\n      font-weight: 500;\n    }\n\n    a {\n      color: #318afb;\n    }\n  }\n}\n\n.totalPrice {\n  flex: 1;\n  letter-spacing: 0;\n  font-size: 15px;\n  color: #1b2432;\n  letter-spacing: 0;\n  font-weight: bold;\n}\n\n.segmentDetail {\n  border: none !important;\n  webkit-box-shadow: none !important;\n  -moz-box-shadow: none !important;\n  box-shadow: none !important;\n\n  .container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin: 32px 32px 0 32px;\n\n    .destinations {\n      font-size: 30px;\n      color: #1b2432;\n      letter-spacing: 0;\n      min-width: 180px;\n      align-self: center;\n\n      svg {\n        margin: 0 20px;\n      }\n    }\n\n    .details {\n      font-size: 25px;\n      color: #1b2432;\n      letter-spacing: 0;\n      margin: 0;\n    }\n\n    .labels {\n      font-size: 11px;\n      color: #6d717a;\n      letter-spacing: 0;\n      margin-bottom: 8px;\n      margin-top: 0;\n      font-weight: 400;\n    }\n    .airline {\n      margin-bottom: 0;\n    }\n  }\n\n  .buttons {\n    .button {\n      color: #318afb;\n      min-width: 74px;\n      height: 32px;\n    }\n  }\n  .withBorder {\n    border-bottom: 1px solid #dddee0;\n  }\n}\n\n.hotelBookingDetails {\n  padding: 32px;\n  padding-bottom: 0;\n  margin-bottom: 32px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);\n\n  .header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    border-bottom: 1px solid #dddee0;\n    padding-bottom: 12px;\n    text-align: left;\n    align-items: center;\n\n    .title {\n      font-size: 13px;\n      color: #6d717a;\n      letter-spacing: 0;\n    }\n\n    .description {\n      font-size: 15px;\n      color: #1b2432;\n      letter-spacing: 0;\n      font-weight: 500;\n    }\n\n    .confNumb {\n      font-size: 11px;\n      color: #6d717a;\n      letter-spacing: 0;\n      margin-bottom: 4px;\n    }\n\n    .confNumb + p {\n      margin-top: 8px;\n    }\n\n    .hotelName {\n      font-size: 21px;\n      color: #1b2432;\n      letter-spacing: 0;\n      margin: 0;\n\n      .title {\n        margin-top: 6px;\n      }\n    }\n  }\n\n  .hotelInfo {\n    display: flex;\n    flex-direction: row;\n    border-bottom: 1px solid #dddee0;\n    padding: 12px 0;\n    text-align: left;\n\n    .title {\n      font-size: 13px;\n      color: #6d717a;\n      letter-spacing: 0;\n      margin-bottom: 4px;\n    }\n\n    .description {\n      font-size: 15px;\n      color: #1b2432;\n      letter-spacing: 0;\n      font-weight: 500;\n      margin-top: 2px;\n      padding-right: 40px;\n    }\n  }\n\n  .placeInfo {\n    display: flex;\n    flex-direction: row;\n    padding: 12px 0;\n    text-align: left;\n    align-items: center;\n    justify-content: space-between;\n\n    .star {\n      display: flex;\n      align-items: center;\n\n      .description {\n        padding-right: 40px;\n        font-size: 15px;\n        color: #6d717a;\n      }\n    }\n\n    .rating {\n      text-align: right;\n\n      .ratingText {\n        font-family: 'Roboto';\n        font-weight: 500;\n        font-size: 15px;\n        color: #008e64;\n        letter-spacing: 0;\n        text-align: right;\n        margin-bottom: 6px;\n      }\n\n      .ratingCount {\n        margin-top: 6px;\n        font-family: 'Roboto';\n        font-weight: 400;\n        font-size: 13px;\n        color: #6d717a;\n        letter-spacing: 0;\n        text-align: right;\n      }\n    }\n  }\n}\n\n.cancelInfoIcon {\n  align-self: center;\n  cursor: pointer;\n}\n\n.confirmationBodyTextStyle {\n  width: 450px;\n  padding-left: 32px !important;\n  padding-right: 32px !important;\n  padding-bottom: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hotelDetails": `components-BookingDetails-Hotel-styles___hotelDetails--Ssh0u`,
	"numbers": `components-BookingDetails-Hotel-styles___numbers--RwPfQ`,
	"highlight": `components-BookingDetails-Hotel-styles___highlight--VtLBd`,
	"hotelDetailsTitle": `components-BookingDetails-Hotel-styles___hotelDetailsTitle--Ch6GQ`,
	"row": `components-BookingDetails-Hotel-styles___row--C81Zz`,
	"noBorder": `components-BookingDetails-Hotel-styles___no-border--jbJzY`,
	"baseFare": `components-BookingDetails-Hotel-styles___baseFare--zz2Zg`,
	"baseprice": `components-BookingDetails-Hotel-styles___baseprice--abWrz`,
	"price": `components-BookingDetails-Hotel-styles___price--CQHU4`,
	"fees": `components-BookingDetails-Hotel-styles___fees--CcTnn`,
	"title": `components-BookingDetails-Hotel-styles___title--HL2s5`,
	"subtitle": `components-BookingDetails-Hotel-styles___subtitle--QbI3p`,
	"cancelPolicyRow": `components-BookingDetails-Hotel-styles___cancelPolicyRow--E5s_c`,
	"cancelPolicy": `components-BookingDetails-Hotel-styles___cancelPolicy--qvO3D`,
	"icon": `components-BookingDetails-Hotel-styles___icon--vD0qF`,
	"withPrice": `components-BookingDetails-Hotel-styles___withPrice--M7MIJ`,
	"total": `components-BookingDetails-Hotel-styles___total--ozZxo`,
	"dropdown": `components-BookingDetails-Hotel-styles___dropdown--ObArS`,
	"rotate": `components-BookingDetails-Hotel-styles___rotate--WsTBU`,
	"buttonWrapper": `components-BookingDetails-Hotel-styles___buttonWrapper--gaZ1G`,
	"button": `components-BookingDetails-Hotel-styles___button--EqoQ2`,
	"warningContainer": `components-BookingDetails-Hotel-styles___warning_container--KpBI6`,
	"warning": `components-BookingDetails-Hotel-styles___warning--QSIT6`,
	"multiWarning": `components-BookingDetails-Hotel-styles___multiWarning--ldukT`,
	"terms": `components-BookingDetails-Hotel-styles___terms--n_cdY`,
	"totalPrice": `components-BookingDetails-Hotel-styles___totalPrice--vuMIv`,
	"segmentDetail": `components-BookingDetails-Hotel-styles___segmentDetail--raleY`,
	"container": `components-BookingDetails-Hotel-styles___container--jiKBx`,
	"destinations": `components-BookingDetails-Hotel-styles___destinations--v2KAw`,
	"details": `components-BookingDetails-Hotel-styles___details--VvEKt`,
	"labels": `components-BookingDetails-Hotel-styles___labels--BYeB7`,
	"airline": `components-BookingDetails-Hotel-styles___airline--is3Ln`,
	"buttons": `components-BookingDetails-Hotel-styles___buttons--Rofiq`,
	"withBorder": `components-BookingDetails-Hotel-styles___withBorder--rPgWl`,
	"hotelBookingDetails": `components-BookingDetails-Hotel-styles___hotelBookingDetails--Te7N0`,
	"header": `components-BookingDetails-Hotel-styles___header--eI1uo`,
	"description": `components-BookingDetails-Hotel-styles___description--JGVw0`,
	"confNumb": `components-BookingDetails-Hotel-styles___confNumb--wUY3s`,
	"hotelName": `components-BookingDetails-Hotel-styles___hotelName--yT6Ky`,
	"hotelInfo": `components-BookingDetails-Hotel-styles___hotelInfo--Z3QPx`,
	"placeInfo": `components-BookingDetails-Hotel-styles___placeInfo--DRlKU`,
	"star": `components-BookingDetails-Hotel-styles___star--U9Tkm`,
	"rating": `components-BookingDetails-Hotel-styles___rating--zrhnQ`,
	"ratingText": `components-BookingDetails-Hotel-styles___ratingText--jZXKG`,
	"ratingCount": `components-BookingDetails-Hotel-styles___ratingCount--RD6SX`,
	"cancelInfoIcon": `components-BookingDetails-Hotel-styles___cancelInfoIcon--MirQU`,
	"confirmationBodyTextStyle": `components-BookingDetails-Hotel-styles___confirmationBodyTextStyle--NhueW`
};
module.exports = ___CSS_LOADER_EXPORT___;
